//This below configuration not used anymore
export default {
  header: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "fas fa-chart-area",
        page: "dashboard",
        bullet: "dot",
      },
      {
        title: "Menu",
        root: true,
        icon: "fas fa-th",
        page: "menu",
        bullet: "dot",
      },
    ],
  },
  aside: {
    self: {},
    items: [
      {
        title: "Dashboard",
        root: true,
        icon: "fas fa-chart-area",
        page: "dashboard",
        bullet: "dot",
      },
      /*{ section: "Modules" },
      {
        title: "CRM",
        root: true,
        bullet: "dot",
        icon: "fas fa-people-arrows",
        submenu: [
          {
            title: "Leads",
            page: "crm/leads",
          },
          {
            title: "Support",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Inquiry",
                page: "crm/inquiry",
              },
              {
                title: "Ticket",
                page: "crm/ticket",
              },
            ],
          },
          {
            title: "Sales Life Cycle",
            page: "crm/slc",
          },
          {
            title: "Sales Journey",
            page: "crm/sales-journey",
          },
        ],
      },
      {
        title: "Sales",
        root: true,
        bullet: "dot",
        icon: "fas fa-store",
        submenu: [
          {
            title: "Outlets",
            page: "sales/outlets",
          },
          {
            title: "Customers",
            page: "sales/customers",
          },
          {
            title: "Quotations",
            page: "sales/quotation/quotation-list",
          },
          {
            title: "Sales Orders",
            page: "sales/sales-order/sales-order-list",
          },
          {
            title: "Point of Sales",
            page: "sales/pos",
          },
          {
            title: "E-Commerce",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Shops",
                page: "#",
              },
              {
                title: "Orders",
                page: "#",
              },
            ],
          },
        ],
      },
      {
        title: "Inventory",
        root: true,
        bullet: "dot",
        icon: "fas fa-boxes",
        submenu: [
          {
            title: "Warehouses",
            page: "inventory/warehouses",
          },
          {
            title: "Operation Life Cycle",
            page: "inventory/olc",
          },
          {
            title: "Items",
            page: "inventory/items",
          },
          {
            title: "Stock Management",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Items Receive",
                page: "inventory/stock-management/items-receive",
              },
              {
                title: "Items Transfer",
                page: "inventory/stock-management/items-transfer",
              },
              {
                title: "Items Reservation",
                page: "inventory/stock-management/items-reservation",
              },
              {
                title: "Delivery",
                page: "inventory/stock-management/delivery",
              },
            ],
          },
        ],
      },
      {
        title: "Procurement",
        root: true,
        bullet: "dot",
        icon: "fas fa-shopping-cart",
        submenu: [
          {
            title: "Vendors",
            page: "inventory/vendors",
          },
          {
            title: "Purchase Order",
            page: "inventory/procurement/purchase-order/purchase-order-list",
          },
        ],
      },
      {
        title: "Finance",
        root: true,
        bullet: "dot",
        icon: "fas fa-money-bill-wave",
        submenu: [
          {
            title: "Invoices",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Invoice",
                page: "finance/invoice",
              },
              {
                title: "Incoming Invoice",
                page: "finance/incoming-invoice",
              },
            ],
          },
          {
            title: "Payments",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Incoming Payment",
                page: "finance/create-incoming-payment",
              },
              {
                title: "Outgoing Payment",
                page: "finance/create-outgoing-payment",
              },
            ],
          },
        ],
      },
      {
        title: "Users",
        root: true,
        bullet: "dot",
        icon: "fas fa-user-friends",
        submenu: [
          {
            title: "Users",
            page: "users/user-list",
          },
          {
            title: "User Groups",
            page: "users/user-group",
          },
          {
            title: "Authorization",
            page: "users/authorization",
          },
          {
            title: "Approval",
            page: "users/approval",
          },
        ],
      },
      { section: "Configurations" },
      {
        title: "Setup",
        root: true,
        bullet: "dot",
        icon: "fas fa-cogs",
        submenu: [
          {
            title: "Company Profile",
            bullet: "dot",
            page: "setup/company-profile-setup",
          },
          {
            title: "Finance",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Fiscal Year Period",
                page: "setup/finance/period",
              },
              {
                title: "Currency",
                page: "setup/finance/currency",
              },
              {
                title: "Tax",
                page: "setup/finance/tax",
              },
              {
                title: "Chart of Account",
                page: "setup/finance/coa",
              },
            ],
          },
          {
            title: "Inventory",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Items",
                root: true,
                bullet: "dot",
                submenu: [
                  {
                    title: "Brand",
                    page: "setup/inventory/items/brand",
                  },
                  {
                    title: "Category",
                    page: "setup/inventory/items/category",
                  },
                  {
                    title: "Uom",
                    page: "setup/inventory/items/uom",
                  },
                  {
                    title: "Variant",
                    page: "setup/inventory/items/variant",
                  },
                ],
              },
            ],
          },
          {
            title: "Customer",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Business Size",
                page: "setup/customer/business-size",
              },
              {
                title: "Industry Type",
                page: "setup/customer/industry-type",
              },
              {
                title: "Source",
                page: "setup/customer/source",
              },
            ],
          },
          {
            title: "Sales",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Sales Target Company",
                page: "setup/sales/sales-target-company",
              },
              {
                title: "Sales Target Users",
                page: "setup/sales/sales-target-users",
              },
            ],
          },
          {
            title: "Operation",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Operation Type",
                page: "setup/operation/operation-type",
              },
              {
                title: "Operation Status",
                page: "setup/operation/operation-status",
              },
            ],
          },
          {
            title: "CRM",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "IMAP Email Setup",
                page: "setup/crm/imap-email-setup",
              },
              {
                title: "Blocked Email",
                page: "setup/crm/blocked-email",
              },
              {
                title: "Service Level Agreement",
                page: "setup/crm/service-agreement",
              },
              {
                title: "Service",
                page: "setup/crm/service",
              },
              {
                title: "Sales Activity",
                page: "setup/crm/sales-activity",
              },
              {
                title: "Priority",
                page: "setup/crm/priority",
              },
              {
                title: "Sales Life Cycle Status",
                page: "setup/crm/sales-life-cycle-status",
              },
            ],
          },
          {
            title: "User",
            root: true,
            bullet: "dot",
            submenu: [
              {
                title: "Task Status",
                page: "setup/user/task-status",
              },
            ],
          },
        ],
      },*/
    ],
  },
};
